import { render, staticRenderFns } from "./Events.vue?vue&type=template&id=59e13376&scoped=true&"
import script from "./Events.vue?vue&type=script&lang=js&"
export * from "./Events.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e13376",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59e13376')) {
      api.createRecord('59e13376', component.options)
    } else {
      api.reload('59e13376', component.options)
    }
    module.hot.accept("./Events.vue?vue&type=template&id=59e13376&scoped=true&", function () {
      api.rerender('59e13376', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/traceability/Events.vue"
export default component.exports